import { createFileRoute } from "@tanstack/react-router";
import { TeacherProfilePage } from "@/projects/teacher/pages/ProfilePage";

export const Route = createFileRoute("/teacher/profile")({
  head: () => ({ meta: [{ title: "Profile — Teacher" }] }),
  component: TeacherProfilePage,
});
